interface Params {
  isAuthenticated: boolean;
  totalMatches: number;
  totalExactMatches: number;
  itemsPerPage: number;
}

interface PaginationVisibility {
  showPaginationInExactMatchList: boolean;
  showPaginationInPossibleMatchList: boolean;
}

export const getPaginationVisibility = ({
  isAuthenticated,
  totalMatches,
  totalExactMatches,
  itemsPerPage,
}: Params): PaginationVisibility => {
  if (!isAuthenticated || totalMatches <= itemsPerPage) {
    return {
      showPaginationInExactMatchList: false,
      showPaginationInPossibleMatchList: false,
    };
  }

  if (totalExactMatches >= itemsPerPage) {
    return {
      showPaginationInExactMatchList: true,
      showPaginationInPossibleMatchList: false,
    };
  }

  return {
    showPaginationInExactMatchList: false,
    showPaginationInPossibleMatchList: true,
  };
};
